cb.define([], function () {
  var AA_aa_posdevicesettinglist_VM_extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
      let gridModel = viewmodel.getGridModel();
		  gridModel.on('afterSetDataSource', () => {
  
		  const rows = gridModel.getRows();
		  const actions = gridModel.getCache('actions');
		  const actionsStates = [];
		  rows.forEach(data => {
			// debugger
			const actionState = { };
			actions.forEach(action => {
        actionState[action.cItemName] = { visible: true };
        if(data.templateType==0){
          actionState["btnDelete"] = { visible: false };
        }
			  });
		  	actionsStates.push(actionState);
		  });
		  gridModel.setActionsState(actionsStates);
		});
    }
  }
  try {
    module.exports = AA_aa_posdevicesettinglist_VM_extend;
  } catch (error) {

  }
  return AA_aa_posdevicesettinglist_VM_extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_posdevicesettinglist_VM.Extend.js